<template lang="pug">
  v-dialog(:value="value", persistent, width="360", @input="$emit('input', $event)")
    v-card.sign-up-modal.spam-reminder-modal
      figure
        img(:src="iconInforma" alt="Revisar Spam")
      h2.omnesMedium.text-blue-gray
        | Hemos enviado tu código
        br
        | de verificación
      p Revisa tu correo electrónico registrado. También revisar la carpeta de spam o correo no deseado.
      button.omnesSemibold.zs-btn-fill.fuchsia(@click="close") Entendido
</template>

<script>
export default {
  name: 'SpamReminderModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      iconInforma: require('@/assets/characters/informaCorreo.svg')
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.sign-up-modal.spam-reminder-modal {
  height: 450px;
  box-sizing: border-box;
  padding: 35px 45px 50px 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sign-up-modal.spam-reminder-modal figure {
  margin: 0;
}

.sign-up-modal.spam-reminder-modal h2,
.sign-up-modal.spam-reminder-modal p {
  width: 100%;
  margin: 10px 0 0;
  text-align: center;
}

.sign-up-modal.spam-reminder-modal button {
  margin: 24px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SpamReminderModal.vue